import Filter from '@/views/filter/Filter';
import Search from '@/views/Search';
import {
  ADDRESS_PATH,
  GROUP_PATH,
  INTERNAL_DATA_VIEW_CREATION_LOG_PATH,
  INTERNAL_DRAFT_DATA_VIEW_PATH,
  INTERNAL_PATH,
  LEVEL3_PATH,
  LISTS_BASE_PATH,
  LISTS_DETAIL_PATH,
  LISTS_SPAN_PATH,
  POINT_PATH,
  PROGRAM_BASE_PATH,
  PROGRAM_PLANS_PATH,
  PLAN_DETAIL_PATH,
  PROJECTS_PATH,
  CREATE_PROJECT_PATH,
  PROJECT_DETAIL_PATH,
  PROJECT_SPAN_PATH,
  VEGETATION_INTELLIGENCE_PATH,
} from './constants';
import { lazy, type LazyExoticComponent } from 'react';
import ClientSelector from '@/views/ClientSelector';
import { AnalysisRoute } from '@/views/AnalysisRoute';

const ProgramListWrapper = lazy(
  () => import('@/views/program/ProgramListWrapper')
);
const Plan = lazy(() => import('@/views/program/Plan'));

const PlansOverview = lazy(
  () => import('@/views/program/components/PlansOverview/PlansOverview')
);
const Dashboard = lazy(() => import('@/views/Dashboard'));
const InternalTools = lazy(() => import('@/views/InternalTools'));
const DraftDataView = lazy(
  () => import('@/views/internalTools/data-views/draft/DraftDataView')
);
const DataViewCreationLog = lazy(
  () => import('@/views/internalTools/data-views/DataViewCreationLog')
);
const VegetationIntelligence = lazy(
  () => import('@/views/vegetationIntelligence/VegetationIntelligence')
);
const NotFound = lazy(() => import('@/views/NotFound'));

interface Route {
  key: string;
  path: string;
  name: string;
  component: React.ComponentType | LazyExoticComponent<React.ComponentType>;
  props?: Record<string, unknown>;
}

const routes: Route[] = [
  {
    key: 'analyze-map',
    path: '/',
    name: 'Map',
    component: AnalysisRoute,
  },
  {
    key: 'landing',
    path: '/client/:code',
    name: 'Landing',
    component: ClientSelector,
  },
  {
    key: 'analyze-map',
    path: LEVEL3_PATH,
    name: 'Map',
    component: AnalysisRoute,
  },
  {
    key: 'analyze-map-group',
    path: GROUP_PATH,
    name: 'Map',
    component: AnalysisRoute,
  },
  {
    key: 'analyze-map-address',
    path: ADDRESS_PATH,
    name: 'Map',
    component: AnalysisRoute,
  },
  {
    key: 'analyze-map-point',
    path: POINT_PATH,
    name: 'Map',
    component: AnalysisRoute,
  },
  {
    key: 'analyze-map-list-overview',
    path: LISTS_BASE_PATH,
    name: 'All Projects',
    component: AnalysisRoute,
  },
  {
    key: 'analyze-map-list-detail',
    path: LISTS_DETAIL_PATH,
    name: 'Project Detail',
    component: AnalysisRoute,
  },
  {
    key: 'analyze-map-list-span',
    path: LISTS_SPAN_PATH,
    name: 'Project Span Detail',
    component: AnalysisRoute,
  },
  {
    key: 'projects',
    path: PROJECTS_PATH,
    name: 'Projects',
    component: AnalysisRoute,
  },
  {
    key: 'create-project',
    path: CREATE_PROJECT_PATH,
    name: 'Create project',
    component: AnalysisRoute,
  },
  {
    key: 'project-detail',
    path: PROJECT_DETAIL_PATH,
    name: 'Project',
    component: AnalysisRoute,
  },
  {
    key: 'project-span',
    path: PROJECT_SPAN_PATH,
    name: 'Project',
    component: AnalysisRoute,
  },
  {
    key: 'analyze-filter',
    path: '/filter',
    name: 'Filter',
    component: Filter,
  },
  {
    key: 'dashboard',
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    key: 'search',
    path: '/search',
    name: 'Search',
    component: Search,
  },
  {
    key: 'vegetation-intelligence',
    path: VEGETATION_INTELLIGENCE_PATH,
    name: 'Vegetation Intelligence',
    component: VegetationIntelligence,
  },
  {
    key: 'internal',
    path: INTERNAL_PATH,
    name: 'Internal tools',
    component: InternalTools,
  },
  {
    key: 'internal-draft-data-view',
    path: INTERNAL_DRAFT_DATA_VIEW_PATH,
    name: 'Draft a data view',
    component: DraftDataView,
  },
  {
    key: 'internal-data-view-creation-log',
    path: INTERNAL_DATA_VIEW_CREATION_LOG_PATH,
    name: 'Full data log',
    component: DataViewCreationLog,
  },
  {
    key: 'error-notfound',
    path: '/404',
    name: '404',
    component: NotFound,
  },
];

export const programRoutes: Route[] = [
  {
    key: 'program',
    path: PROGRAM_BASE_PATH,
    name: 'Cycle Schedule',
    component: ProgramListWrapper,
  },
  {
    key: 'program-plans-overview',
    path: PROGRAM_PLANS_PATH,
    name: 'Plans Overview',
    component: PlansOverview,
  },
  {
    key: 'plan-detail',
    path: PLAN_DETAIL_PATH,
    name: 'Plan Detail',
    component: Plan,
  },
];

export default routes;
